module.exports = __webpack_public_path__ + "img/gates.e7c5e829.webp";